var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Datatable',{attrs:{"id":"loyaltyAccounts","entity":"loyalty_account","parameters":{branch: _vm.$route.query.branch},"onRowClick":_vm.show,"rowActions":[{text: 'loyalty_transactions.show', method: _vm.show}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }